import React from 'react';
import { flag } from '../config';
import HeaderLegacy from './HeaderLegacy';
import SiteHeader from './site/header/SiteHeader';

/**
 * The site header, mounted by layouts/PublicLayout (remounted per path). With SLOT_MODEL on
 * it is the redesigned SiteHeader (components/site/header, approved Sept 26 2026); with the
 * flag off it is HeaderLegacy, the pre-redesign header, unchanged (its markup is pinned
 * against earlier commits by phase5c.routes.qa and phase6.chrome.qa). Both render nothing
 * on /admin*. Tests mock this module by path: keep the path and the default export.
 */
export default function Header() {
  return flag('SLOT_MODEL') ? <SiteHeader /> : <HeaderLegacy />;
}
